module.exports = __webpack_public_path__ + "static/media/coin_voucher.fdaa01f6.png";